import React from 'react';
import {Link} from 'react-router-dom';

import archiveBttn from '../../../../icons/folder-with-color.svg';

import classes from './OpenArchiveButton.css';

const openArchiveButton = props => {

    let archiveButtonStyle = [classes.ArchiveButton];

    if (props.disabled) {
        archiveButtonStyle.push(classes.Disabled);
    }

    return (        
        <Link to={props.linkName} >
            <img src={archiveBttn} className={archiveButtonStyle.join(' ')} alt="Error 404"/>
        </Link>
    )
}

export default openArchiveButton


// WEBPACK FOOTER //
// ./src/components/UI/Buttons/OpenArchiveButton/OpenArchiveButton.js